<template lang="pug">
transition(name="slide-fade")
  .box.py-2.px-4.is-clickable.vuecal__event.split-event(:class="[statusColorClass, statusTextColorClass]" v-if="minimized" @click="minimize(false)")
    .is-flex.is-justify-content-space-between.is-align-items-center
      div
        p.is-size-5.has-text-weight-semibold(style="text-transform: capitalize") {{ longDateFormatter(start) }}
        p(v-if="serviceItem")
          service-name-view(:value="{service: serviceItem.service.serviceId, option: serviceItem.service.optionId}")
        p(v-else) {{ $t('misc.draft_event') }}
      div
        p.is-size-5.has-text-weight-semibold 
        span.icon
          i.mdi.mdi-arrow-top-left-bottom-right.mdi-24px
  .modal-card(v-else)
    header.modal-card-head.py-5(:class="[statusColorClass, statusTextColorClass]" style="align-items: flex-start")
      //p.modal-card-title(data-qa="modal-header") 
      div.is-flex-grow-1 
        .is-flex.is-align-items-center
          div
            localized-datepicker.mb-2(v-model="start" :date-formatter="longDateFormatter" expanded size="is-medium" :mobile-native="false")
              template(v-slot:trigger)
                p.is-size-4.has-text-weight-bold.is-clickable(style="text-transform: capitalize") 
                  span {{ longDateFormatter(start) }}
                  span.icon
                    i.mdi.mdi-chevron-down

        .is-flex.is-align-items-center
          div
            a(:class="statusTextColorClass" @click="editRepeatPattern")  
              RepeatPatternView(:value="repeat")
          div 
            location-select.is-size-6.has-text-weight-semibold(v-model="location" :dropdown="false" :class="statusTextColorClass") 
      
      div
        div.has-text-right.mb-2 
          a.button.is-small.is-ghost.mr-2(v-if="!isMobile()" @click="minimize(true)" :class="statusTextColorClass")
            span.icon
              i.mdi.mdi-format-vertical-align-bottom.mdi-24px
          a.button.is-small.is-ghost(@click="confirmClose" :class="statusTextColorClass")
            span.icon
              i.mdi.mdi-close.mdi-24px
        //div(v-if="appointment")
          AppointmentStatusDropdown.is-small(:appointmentId="appointment._id" :button-color="buttonColor")
    section.modal-card-body.is-flex.is-flex-direction-column.is-clipped.p-0.is-relative(ref="mainContent" style="flex-flow: nowrap")
        em-loading(:active="loading" :is-full-page="false")
        template(v-if="!serviceItem")
          ServiceListSelect(:locationId="locationId" @input="onServiceSelect" style="width: 100%; overflow: hidden" type="group")
        
        .is-flex-grow-1(style="overflow:scroll" v-else)
          .p-4
              AppointmentItemEdit(
                v-model="serviceItem" 
                :locationId="location" 
                :date="start"
                :removable="false")    
          .px-4
            b-field(:label="$t('appointment.participants_label')")
              b-numberinput(v-model="capacity"
                  controls-alignment="right" 
                  controls-position="compact" type="is-light" :min="1" :max="10000000" step="1" )
          //div.px-4
            label.label {{ $t('appointment.capacity') }}
            button.button.is-rounded.is-small(@click.stop="decreaseCapacity" style="padding-left: 1em; padding-right: 1em")
              span.icon
                i.mdi.mdi-minus.mdi-24px
            button.button.is-white.is-small
              span.is-size-5.has-text-weight-semibold {{capacity}}  
            button.button.is-rounded.is-small(@click.stop="increaseCapacity" style="padding-left: 1em; padding-right: 1em")
              span.icon
                i.mdi.mdi-plus.mdi-24px
          hr
          .tabs.is-toggle
            ul(style="border-bottom-color: transparent")
              li(:class="participantsFilter === 'signups' ? 'is-active' : ''")
                a(style="border-radius: 999px" @click="participantsFilter = 'signups'") {{ $t('appointment.event_signups') }}
                  span.tag.is-small.ml-2(:class="participantsFilter === 'signups' ? 'is-white': 'is-light'" style="height: 1.5em; width: 1.5em" v-if="participantSections.signups") {{participantSections.signups}}
              li(:class="participantsFilter === 'checkedin' ? 'is-active' : ''")
                a(style="border-radius: 999px" @click="participantsFilter = 'checkedin'") {{ $t('appointment.event_checked_in') }}
                  span.tag.is-small.ml-2(:class="participantsFilter === 'checkedin' ? 'is-white': 'is-light'" style="height: 1.5em; width: 1.5em" v-if="participantSections.checkedin") {{participantSections.checkedin}}
              li(:class="participantsFilter === 'canceled' ? 'is-active' : ''")
                a(style="border-radius: 999px" @click="participantsFilter = 'canceled'") {{ $t('appointment.event_canceled') }} 
                  span.tag.is-small.ml-2(:class="participantsFilter === 'canceled' ? 'is-white': 'is-light'" style="height: 1.5em; width: 1.5em" v-if="participantSections.canceled") {{participantSections.canceled}}
              li(:class="participantsFilter === 'waiting_list' ? 'is-active is-danger' : ''")
                a(style="border-radius: 999px" @click="participantsFilter = 'waiting_list'") {{ $t('appointment.event_waiting_list') }} 
                  span.tag.is-small.ml-2(:class="participantsFilter === 'waiting_list' ? 'is-white': 'is-light'" style="height: 1.5em; width: 1.5em" v-if="participantSections.waiting_list") {{participantSections.waiting_list}}
          
          b-table(:data="filteredParticipants" :loading="enrolling" :show-detail-icon="false" detailed detail-key="customer" striped hoverable)
            template(slot="empty")
              p.has-text-centered(v-if="participantsFilter === 'signups'") {{ $t('appointment.no_participants') }}
              p.has-text-centered(v-else-if="participantsFilter === 'checkedin'") {{ $t('appointment.no_checkins') }}
              p.has-text-centered(v-else-if="participantsFilter === 'canceled'") {{ $t('appointment.no_cancelations') }}
              p.has-text-centered(v-else-if="participantsFilter === 'waiting_list'") {{ $t('appointment.no_waiting_list') }}
            template(#detail="props")
              div
                label.label(v-t="'appointment_history.title'")
                AppointmentStatusHistory(:value="props.row")
                //.buttons
                  button.button.is-success.is-outlined(@click="props.toggleDetails(props.row)") Checkout
                  //action-button.is-success.is-outlined(@click="onCheckout(props.row.customer)" :disabled="notCheckoutable" icon="basket" permission="SALE_CREATE" data-qa="action-checkout")
                  button.button.is-danger.is-outlined(@click="removeParticipant(props.row.customer)")
                    span.icon
                      i.mdi.mdi-delete
            b-table-column(field="firstName" :label="$t('appointment.event_client_label')" v-slot="props")
              customer-name.has-text-weight-semibold(:value="props.row.customer" link showIsNew :class="props.row.status === APPOINTMENT_STATUS.DRAFT ? 'has-text-grey' : ''")
              b-tooltip(:label="props.row.clientNotes" v-if="props.row.clientNotes" append-to-body multilined type="is-dark")
                span.icon
                  i.mdi.mdi-comment-text-outline
            b-table-column(field="created" :label="$t('appointment.event_enrolled_label')" v-slot="props")
              date-view.is-size-7(:value="props.row.created" format="LT L")
            b-table-column(field="minLeadTime" :label="$t('appointment.event_min_lead_time_label')" v-slot="props" :visible="participantsFilter === 'waiting_list'")
              duration-view(:value="props.row.minLeadTime") 
            b-table-column(field="payment" :label="$t('appointment.event_payment_label')" v-slot="props" :visible="participantsFilter !== 'waiting_list'")
              template(v-if="props.row.sale") 
                invoice-view(:value="props.row.sale")
              AppointmentStatusIcon(show-text is-tag tag-size="is-small" v-else-if="props.row.status === APPOINTMENT_STATUS.INCOMPLETE || props.row.status === APPOINTMENT_STATUS.DRAFT" :status="props.row.status")
              template(v-else)
                payment-view(:value="props.row.payment" v-if="props.row.payment")
                //EligibleMemberships(:customerId="props.row.customer" :service="serviceItem.service")
                CustomerMembershipTagView(:value="props.row.membership" v-if="props.row.membership")
            b-table-column(field="actions" label="" v-slot="props")
              .is-flex(style="text-align: right; flex-wrap: nowrap; justify-content: end")
                //button.button.is-success.is-small(v-if="!props.row.sale" @click="props.toggleDetails(props.row)") Checkout
                action-button.is-success.is-small(v-if="isCheckoutable(props.row)" @click="onCheckout(props.row.customer)" icon="basket-outline" permission="SALE_CREATE" data-qa="action-checkout" title="actions.checkin")
                b-dropdown(position="is-bottom-left" append-to-body)
                  template(#trigger)
                    button.button.is-white.is-small
                      span.icon
                        i.mdi.mdi-dots-vertical.mdi-24px
                  b-dropdown-item(@click="showTerminationModal(props.row.customer, APPOINTMENT_STATUS.CANCELED)" :disabled="!isCheckoutable(props.row)" v-if="participantsFilter !== 'waiting_list'")
                    span {{ $t('appointment.actions.cancel') }}
                  b-dropdown-item(@click="showTerminationModal(props.row.customer, APPOINTMENT_STATUS.NOSHOW)" :disabled="!isCheckoutable(props.row)" v-if="participantsFilter !== 'waiting_list'")
                    span {{ $t('appointment.actions.noshow') }}
                  b-dropdown-item(@click="onTerminateParticipation(props.row.customer, APPOINTMENT_STATUS.WAITING_LIST)" :disabled="!isCheckoutable(props.row)")
                    span {{ $t('appointment.actions.move_to_waiting_list') }}
                  b-dropdown-item(@click="recover(props.row.customer)" v-if="participantsFilter === 'waiting_list'")
                    span {{ $t('appointment.actions.move_to_signups') }}
                  b-dropdown-item.is-danger(@click="onTerminateParticipation(props.row.customer, APPOINTMENT_STATUS.WAITING_LIST)" v-if="participantsFilter === 'waiting_list'")
                    span.has-text-danger {{ $t('actions.remove') }}
                  b-dropdown-item(separator)
                  b-dropdown-item(@click="props.toggleDetails(props.row)") 
                    span(v-t="'appointment_history.title'")
                  b-dropdown-item(@click="recover(props.row.customer)" :disabled="!canBeRecovered(props.row)" v-if="participantsFilter !== 'waiting_list'")
                    span {{ $t('appointment.actions.recover') }}
                  // b-dropdown-item(separator)
                  // b-dropdown-item(@click="removeClient(props.row.customer)" v-if="!props.row.sale")
                  //   span {{ $t('actions.delete') }}

                
          
          .buttons.is-centered
            button.button.is-outlined.is-primary.is-rounded(@click="openCustomerSelectModal" v-if="!isFull")
              span.icon
                i.mdi.mdi-account-plus-outline
              span {{ $t('actions.enroll_customer') }}
            button.button.is-outlined.is-danger.is-rounded(@click="openCustomerSelectModal" v-else)
              span.icon
                i.mdi.mdi-calendar-clock-outline
              span {{ $t('actions.add_to_waiting_list') }}
            // button.button.is-black.is-outlined.is-rounded(@click="openCustomerSelectModal") 
            //   span.icon
            //     i.mdi.mdi-send-outline
            //   span {{ $t('actions.send_text') }}
          // .px-4
          //   .buttons.is-right
              
          .p-4
            a(v-if="(appointment && !appointment.notes) || (!appointment && !notes)" @click="addNotes") 
              b(v-t="'appointment.add_notes'")
              span.icon
                i.mdi.mdi-note-edit-outline
            .notification.p-4.is-clickable.is-hoverable(@click="addNotes" v-else)
              p {{ notes || appointment.notes }}

            //b-field(:label="$t('appointment.notes_title')")
              b-input.is-fullwidth(v-model="notes" type="textarea" :placeholder="$t('appointment.notes_placeholder')")
          //.p-4(v-if="appointment.payment")
            label.label {{ $t('payment_types.deposit') }}
            payment-view(:value="appointment.payment")
          .p-4.has-background-light(v-if="appointment")
            label.label(v-t="'appointment_history.title'")
            AppointmentStatusHistory(:value="appointment")
        
    footer.modal-card-foot
      div.is-flex-grow-1
        //div 
          h3.title.is-5.mb-4.is-size-6-mobile {{$t('appointment.total_price_label')}}  
            .is-pulled-right
              duration-view.has-text-weight-normal.has-text-grey(:value="totalDuration")
              |  ·    
              span.has-text-weight-semibold
                currency-view(:value="totalPrice")
                template(v-if="totalPrice !== totalPriceUpto") 
                  |  -  
                  currency-view(:value="totalPriceUpto")
              
            
        .buttons.is-right(style="width: 100%")
          div.mr-3
            ColorPicker(v-model="color" position="is-top-right") 
          button.button.is-danger.is-outlined(style="margin-left: auto" @click="abortAppointment" v-if="appointment")
            span.icon
              i.mdi.mdi-dots-horizontal.mdi-24px
          
          action-button.is-outlined(:title="`actions.complete_event`" @click="markAsComplete"  permission="APPOINTMENT_CREATE" data-qa="action-save")
          action-button(:title="`actions.save`" @click="save(true)" :loading="saving" permission="APPOINTMENT_CREATE" data-qa="action-save")
        
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import dayjs from 'dayjs'
import APPOINTMENT_STATUS from '../../../constants/appointmentStatus'
import PERMISSIONS from '../../../constants/permissions'
import APPOINTMENT_TYPES from '../../../constants/appointmentTypes'
import AppointmentItemEdit from './AppointmentItemEdit'

import AppointmentStatusHistory from './AppointmentStatusHistory'
//import AppointmentDetails from './AppointmentDetails'
import CustomerMembershipTagView from '../membership/CustomerMembershipTagView'
import APPT_STATUS_VISUALS from '../../../constants/appointmentStatusVisuals'
import SALE_ITEM_TYPES from '../../../constants/saleItemTypes'
import ColorPicker from './ColorPicker'
import AppointmentStatusDropdown from './AppointmentStatusDropdown'
import Checkout from '../sale/Checkout'
import CustomerSelectModalWrapper from '../shared/CustomerSelectModalWrapper'
import RepeatSelectorModal from './RepeatSelectorModal'
import RepeatPatternView from './RepeatPatternView'
import cloneDeep from 'lodash/cloneDeep'
import EditNotes from './EditNotes'
import isEqual from 'lodash/isEqual'
import ServiceListSelect from '../services/ServiceListSelect'
import AppointmentStatusIcon from './AppointmentStatusIcon'
import EventAbortActions from './EventAbortActions'
import CardPaymentDetails from '../sale/CardPaymentDetails'
import ParticipationAbortActions from './ParticipationAbortActions'
import saleHelper from '../../../shared/saleHelper'

export default {
  name: 'CreateEditEvent',
  components: {
    AppointmentItemEdit,
    ColorPicker,
    AppointmentStatusHistory,
    AppointmentStatusDropdown,
    AppointmentStatusIcon,
    CustomerMembershipTagView,
    RepeatPatternView,
    ServiceListSelect
  },
  props: {
    locationId: {type: String, default: undefined},
    appointmentId: {type: String, default: undefined},
    startDate: {type: Date, default: undefined},
    staffId: {type: String, default: undefined},
    service: {type: Object, default: undefined},
    initialServices: {type: Array, default: undefined},
    resourceId: {type: String, default: undefined},
    rebookingId: {type: String, default: undefined},
    forceFetch: {type: Boolean, default: false}
  },
  data() {
    return {
      capacity: 1,
      serviceItem: undefined,
      start: dayjs()
        .startOf('day')
        .toDate(),
      location: undefined,
      saving: false,
      loading: true,
      enrolling: false,
      color: undefined,
      status: APPOINTMENT_STATUS.NEW,
      APPOINTMENT_STATUS,
      updatingStatus: false,

      // appointment: undefined,
      notes: undefined,
      repeat: undefined,
      minimized: false,
      participantsFilter: 'signups',
      newAppointmentId: undefined
    }
  },

  computed: {
    ...mapState('company', ['company']),
    ...mapState('appointments', ['appointmentsMap']),
    ...mapGetters('memberships', ['customerActiveMemberships']),
    isFull() {
      if (!this.appointment) {
        return false
      }
      return this.appointment.event.remaining <= 0
    },
    statusColorClass() {
      if (this.appointment) {
        return `has-background-${APPT_STATUS_VISUALS[this.appointment.status].color}`
      }
      return 'has-background-light'
    },
    statusTextColorClass() {
      if (this.appointment) {
        return `has-text-${APPT_STATUS_VISUALS[this.appointment.status].text || 'black'}`
      }
      return 'has-text-black'
    },
    buttonColor() {
      if (this.appointment) {
        return `is-${APPT_STATUS_VISUALS[this.appointment.status].text || 'black'}`
      }
      return 'is-black'
    },
    totalPrice() {
      if (!this.serviceItem) {
        return 0
      }
      return this.serviceItem.price || 0
    },
    totalPriceUpto() {
      if (!this.serviceItem) {
        return 0
      }
      return this.serviceItem.priceUpto || this.serviceItem.price || 0
    },
    totalDuration() {
      if (!this.serviceItem) {
        return 0
      }
      return this.serviceItem.duration || 0
    },
    filteredParticipants() {
      if (!this.appointment) {
        return []
      }
      if (this.participantsFilter === 'waiting_list') {
        return this.appointment.participants.filter(p => p.status === APPOINTMENT_STATUS.WAITING_LIST)
      }
      if (this.participantsFilter === 'signups') {
        return this.appointment.participants.filter(p => {
          return (
            p.status !== APPOINTMENT_STATUS.NOSHOW &&
            p.status !== APPOINTMENT_STATUS.CANCELED &&
            p.status !== APPOINTMENT_STATUS.INCOMPLETE &&
            p.status !== APPOINTMENT_STATUS.WAITING_LIST
          )
        })
      } else if (this.participantsFilter === 'checkedin') {
        return this.appointment.participants.filter(p => !!p.sale)
      } else if (this.participantsFilter === 'canceled') {
        return this.appointment.participants.filter(
          p =>
            p.status === APPOINTMENT_STATUS.NOSHOW ||
            p.status === APPOINTMENT_STATUS.CANCELED ||
            p.status === APPOINTMENT_STATUS.INCOMPLETE
        )
      }
      return this.appointment.participants
    },
    participantSections() {
      if (!this.appointment) {
        return {}
      }
      return {
        signups: this.appointment.participants.filter(p => {
          return (
            p.status !== APPOINTMENT_STATUS.NOSHOW &&
            p.status !== APPOINTMENT_STATUS.CANCELED &&
            p.status !== APPOINTMENT_STATUS.INCOMPLETE &&
            p.status !== APPOINTMENT_STATUS.WAITING_LIST
          )
        }).length,
        checkedin: this.appointment.participants.filter(p => !!p.sale).length,
        canceled: this.appointment.participants.filter(
          p =>
            p.status === APPOINTMENT_STATUS.NOSHOW ||
            p.status === APPOINTMENT_STATUS.CANCELED ||
            p.status === APPOINTMENT_STATUS.INCOMPLETE
        ).length,
        waiting_list: this.appointment.participants.filter(p => p.status === APPOINTMENT_STATUS.WAITING_LIST).length
      }
    },
    appointment() {
      if (this.appointmentId || this.newAppointmentId) {
        return this.appointmentsMap[this.appointmentId || this.newAppointmentId] //this.appointmentById(this.appointmentId)
      }
      return undefined
    },
    hasBeenModified() {
      if (!this.appointment && !this.serviceItem) {
        return false
      }
      if (this.appointment && this.serviceItem) {
        let newStart = dayjs(this.start)
          .add(this.serviceItem.start, 'minutes')
          .toDate()
        let s = this.appointment.services[0]
        let item = this.serviceItem
        return (
          this.appointment.event.capacity !== this.capacity ||
          new Date(this.appointment.start).valueOf() !== newStart.valueOf() ||
          this.appointment.color !== this.color ||
          this.appointment.location !== this.location ||
          !isEqual(this.repeat, this.appointment.repeat) ||
          s.service !== item.service.serviceId ||
          s.option !== item.service.optionId ||
          s.price !== item.price ||
          s.priceUpto !== item.priceUpto ||
          s.duration !== item.duration ||
          s.resource !== item.resource ||
          s.blockedTimeAfter !== item.blockedTimeAfter ||
          s.processingTimeAfter !== item.processingTimeAfter ||
          s.staff !== item.staff ||
          this.getTimeOffset(s.start) !== item.start
        )
      }
      return true
    }
  },
  watch: {
    start() {
      this.$emit('startChange', this.start)
    },
    location() {
      this.$emit('locationChange', this.location)
    }
  },

  async created() {
    if (this.appointmentId) {
      await this._fetchAppointment()
    } else if (this.rebookingId) {
      await this._fetchPreviousAppointment()
    } else {
      if (this.initialServices) {
        this.initInitialServices()
      }
      if (this.locationId) {
        this.location = this.locationId
      }
      if (this.startDate) {
        this.start = dayjs(this.startDate)
          .startOf('day')
          .toDate()
      }
    }
    this.$barcodeScanner.init(this.onBarcodeScanned)
    this.loading = false
  },
  destroyed() {
    this.$barcodeScanner.destroy()
  },
  methods: {
    ...mapActions('appointments', [
      'createAppointment',
      'updateAppointment',
      'fetchAppointmentById',
      'enrollParticipant',
      'terminateParticipation',
      'recoverParticipation',
      'completeEvent'
    ]),
    ...mapActions('customers', ['findByCardId']),
    ...mapActions('memberships', ['fetchCustomerMemberships']),
    async onBarcodeScanned(barcode) {
      this.enrolling = true
      try {
        let customer = await this.findByCardId(barcode)
        if (customer) {
          await this.addParticipant(customer)
        } else {
          this.$buefy.toast.open({
            message: this.$t('appointment.customer_not_found'),
            type: 'is-warning',
            queue: false
          })
        }
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.enrolling = false
    },
    minimize(toggle) {
      this.minimized = toggle
      if (toggle) {
        document.getElementsByClassName('half-modal')[0].classList.add('is-minimized')
      } else {
        document.getElementsByClassName('half-modal')[0].classList.remove('is-minimized')
      }
    },
    canBeRecovered(participant) {
      return (
        participant.status === APPOINTMENT_STATUS.CANCELED ||
        participant.status === APPOINTMENT_STATUS.NOSHOW ||
        participant.status === APPOINTMENT_STATUS.INCOMPLETE
      )
    },
    isCheckoutable(participant) {
      return [
        APPOINTMENT_STATUS.NEW,
        APPOINTMENT_STATUS.ARRIVED,
        APPOINTMENT_STATUS.CONFIRMED,
        APPOINTMENT_STATUS.STARTED
      ].includes(participant.status)
    },
    initInitialServices() {
      // let start = this.startDate || new Date()
      // if (start.getHours() === 0 && start.getMinutes() === 0) {
      //   start = new Date()
      // }
      // start.setMinutes(parseInt(start.getMinutes() / 5) * 5, 0, 0)
      // start = start.getHours() * 60 + start.getMinutes()
      let s = this.initialServices[0]
      this.serviceItem = {
        start: this.getTimeOffset(s.start),
        service: {serviceId: s.service, optionId: s.option},
        duration: s.duration,
        price: s.price,
        priceUpto: s.priceUpto,
        blockedTimeAfter: s.blockedTimeAfter,
        processingTimeAfter: s.processingTimeAfter,
        qty: 1,
        staff: s.staff,
        resource: s.resource
      }
    },
    getTimeOffset(date) {
      date = new Date(date)
      return date.getHours() * 60 + date.getMinutes()
    },
    async _fetchAppointment() {
      await this.fetchAppointmentById({id: this.appointmentId, force: this.forceFetch})

      let s = this.appointment.services[0]
      this.capacity = this.appointment.event.capacity
      this.name = this.appointment.event.name
      this.description = this.appointment.event.description
      this.serviceItem = {
        _id: s._id,
        service: {serviceId: s.service, optionId: s.option},
        qty: s.qty || 1,
        price: s.price,
        priceUpto: s.priceUpto,
        duration: s.duration,
        resource: s.resource,
        blockedTimeAfter: s.blockedTimeAfter,
        processingTimeAfter: s.processingTimeAfter,
        staff: (s.staff && s.staff._id) || s.staff,
        preferred: s.preferred,
        preferredResource: s.preferredResource,
        credit: s.credit,
        start: this.getTimeOffset(s.start),
        invalid: undefined
      }
      this.start = dayjs(this.appointment.start)
        .startOf('day')
        .toDate()
      this.location = this.appointment.location

      this.repeat = cloneDeep(this.appointment.repeat)
      // // WORKAROUND - temporary fix delete later
      // if (this.status === APPOINTMENT_STATUS.COMPLETED) {
      //   this.status = APPOINTMENT_STATUS.NEW
      // }
      this.color = this.appointment.color
    },
    async _fetchPreviousAppointment() {
      const rebookedAppt = await this.fetchAppointmentById({id: this.rebookingId})

      const isWithinRebookingWindow =
        this.$rfCRMSettings().rebooking && dayjs().diff(rebookedAppt.start, 'hours') <= this.company.crm.rebookingWindow
      let s = rebookedAppt.services[0]
      this.serviceItem = {
        service: {serviceId: s.service, optionId: s.option},
        qty: s.qty || 1,
        price: s.price,
        priceUpto: s.priceUpto,
        duration: s.duration,
        resource: s.resource,
        blockedTimeAfter: s.blockedTimeAfter,
        processingTimeAfter: s.processingTimeAfter,
        staff: (s.staff && s.staff._id) || s.staff,
        preferred: s.preferred,
        preferredResource: s.preferredResource,
        credit: (isWithinRebookingWindow && ((s.staff && s.staff._id) || s.staff)) || undefined,
        start: this.getTimeOffset(s.start),
        invalid: undefined
      }

      let daysDiff = 7

      this.start = dayjs(rebookedAppt.start)
        .add(daysDiff, 'days')
        .startOf('day')
        .toDate()
      this.location = rebookedAppt.location
    },
    setTime(date, time) {
      return dayjs(date)
        .startOf('day')
        .add(time, 'minutes')
        .toDate()
    },
    async onCheckout(customerId) {
      if (!this.$rfHasPermission(PERMISSIONS.core.SALE_CREATE)) {
        return
      }
      if (!this.$rfHasPermission(PERMISSIONS.core.APPOINTMENT_CREATE)) {
        this.checkout(customerId)
        return
      }
      this.checkout(customerId)
    },
    async markAsComplete() {
      if (this.participantSections.signups !== this.participantSections.checkedin) {
        this.$buefy.toast.open({
          message: this.$t('appointment.event_has_pending_signups'),
          type: 'is-warning',
          queue: false,
          duration: 5000,
          position: 'is-top-right'
        })
      } else {
        if (this.finalizing) {
          return
        }
        this.finalizing = true
        try {
          await this.completeEvent(this.appointment._id)
          this.$emit('close')
        } catch (err) {
          this.$handleAPIError(err)
        }
        this.finalizing = true
      }
    },
    async save(close) {
      try {
        let start = this.serviceItem.start && this.setTime(this.start, this.serviceItem.start)
        let services = [
          {
            //_id: item._id,
            service: this.serviceItem.service && this.serviceItem.service.serviceId,
            option: this.serviceItem.service && this.serviceItem.service.optionId,
            qty: this.serviceItem.qty,
            price: this.serviceItem.price,
            priceUpto: this.serviceItem.priceUpto,
            duration: this.serviceItem.duration,
            resource: this.serviceItem.resource,
            blockedTimeAfter: this.serviceItem.blockedTimeAfter,
            processingTimeAfter: this.serviceItem.processingTimeAfter,
            staff: this.serviceItem.staff,
            preferred: this.serviceItem.preferred,
            preferredResource: this.serviceItem.preferredResource,
            credit: this.serviceItem.credit,
            start
          }
        ]
        let data = {
          event: {capacity: this.capacity, remaining: this.capacity},
          type: APPOINTMENT_TYPES.EVENT,
          services,
          color: this.color,
          location: this.location,
          notes: (!this.appointmentId && this.notes) || undefined,
          repeat: this.repeat,
          previous: this.rebookingId
        }

        data.start = data.services[0].start || this.start

        this.saving = true
        let appt
        if (this.appointment) {
          if (!this.hasBeenModified) {
            this.$emit('close')
            return
          }
          if (this.appointment.repeat) {
            const {result} = await this.$buefy.dialog.confirm({
              title: this.$t('appointment.repeat_appt_change_confirm.title'),

              message: this.$t('appointment.repeat_appt_change_confirm.body'),
              cancelText: this.$t('actions.all_future'),
              confirmText: this.$t('actions.only_this'),
              type: 'is-black',
              canCancel: ['button']
            })
            data.thisOnly = result
          }
          appt = await this.updateAppointment({appointmentId: this.appointment._id, data})
        } else {
          appt = await this.createAppointment(data)
        }
        this.newAppointmentId = appt._id

        this.$buefy.toast.open({message: this.$t('appointment.save_success'), type: 'is-success', queue: false})
        if (close) {
          this.$emit('close')
        }
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.saving = false
    },

    checkout(customerId) {
      this.$buefy.modal.open({
        parent: this.$parent,
        props: {
          appointmentId: this.appointment._id,
          customerId,
          fixedCustomer: true
        },
        component: Checkout,
        hasModalCard: true,
        fullScreen: true,
        canCancel: ['outside']
      })
    },

    onTerminate() {
      this.$emit('close')
    },
    longDateFormatter(date) {
      return dayjs(date).format(this.isMobile() ? 'ddd, D MMMM' : 'ddd, D MMMM')
    },

    async onServiceSelect({serviceId, optionId, capacity}) {
      let start, staff, resource

      start = this.startDate || new Date()
      if (start.getHours() === 0 && start.getMinutes() === 0) {
        start = new Date()
      }
      start.setMinutes(parseInt(start.getMinutes() / 5) * 5, 0, 0)
      start = start.getHours() * 60 + start.getMinutes()
      staff = this.staffId
      resource = this.resourceId

      this.capacity = capacity || 1
      this.serviceItem = {
        start,
        service: {serviceId, optionId},
        invalid: undefined,
        staff,
        resource,
        duration: undefined,
        qty: 1
      }
    },

    async openCustomerSelectModal() {
      if (!this.appointment && !this.$rfHasPermission(PERMISSIONS.core.APPOINTMENT_CREATE)) {
        return
      }
      if (!this.appointment) {
        await this.save()
      }
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        component: CustomerSelectModalWrapper,
        events: {
          input: async customer => {
            await this.addParticipant(customer)
          }
        },
        canCancel: ['escape']
      })
    },
    async addParticipant(customer) {
      if (this.appointment.participants.find(p => p.customer === customer._id)) {
        return this.$buefy.toast.open({
          message: this.$t('appointment.customer_already_added'),
          type: 'is-warning',
          queue: false,
          position: 'is-top-right'
        })
      }
      this.enrolling = true
      try {
        let eligibleMembership = await this.findMembership(customer._id)
        await this.enrollParticipant({
          appointmentId: this.appointment._id,
          customerId: customer._id,
          membershipId: eligibleMembership && eligibleMembership._id
        })
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.enrolling = false
    },
    async findMembership(customerId) {
      await this.fetchCustomerMemberships(customerId)
      let memberships = this.customerActiveMemberships(customerId, this.start)
      let eligibleMembership = saleHelper.findEligibleMembership({
        memberships,
        item: {
          service: this.serviceItem.service.serviceId,
          option: this.serviceItem.service.optionId,
          type: SALE_ITEM_TYPES.SERVICE
        }
      })
      return eligibleMembership
    },
    async recover(customerId) {
      this.enrolling = true
      try {
        let eligibleMembership = await this.findMembership(customerId)
        await this.recoverParticipation({
          appointmentId: this.appointment._id,
          customerId,
          membershipId: eligibleMembership && eligibleMembership._id
        })
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.enrolling = false
    },
    abortAppointment() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        component: EventAbortActions,
        props: {
          appointment: this.appointment
        },
        events: {
          terminated: this.onTerminate
        },
        canCancel: ['escape']
      })
    },
    async onTerminateParticipation(customerId, status) {
      this.enrolling = true
      try {
        let participation = this.appointment.participants.find(p => p.customer === customerId)
        await this.terminateParticipation({appointmentId: this.appointment._id, data: {customer: customerId, status}})
        if (participation.payment) {
          this.$buefy.modal.open({
            parent: this.$parent,
            component: CardPaymentDetails,
            hasModalCard: true,
            props: {
              terminationStatus: status,
              paymentId: participation.payment
            },
            canCancel: []
          })
        }
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.enrolling = false
    },

    showTerminationModal(customerId, status) {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        component: ParticipationAbortActions,
        props: {appointmentId: this.appointment._id, customerId, initialStatus: status},
        canCancel: ['escape']
      })
    },

    editRepeatPattern() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        component: RepeatSelectorModal,
        props: {
          value: this.repeat || {},
          currentDate: this.start
        },
        events: {
          input: pattern => {
            this.repeat = pattern
          }
        },
        canCancel: ['escape']
      })
    },
    setStart(date) {
      if (date.valueOf() !== this.start.valueOf()) {
        this.start = date
      }
    },
    setLocation(locationId) {
      if (this.location !== locationId) {
        this.location = locationId
      }
    },
    confirmClose() {
      if (!this.hasBeenModified) {
        this.$emit('close')
        return
      }

      this.$buefy.dialog.confirm({
        title: this.$t('unsaved_confirm.title'),
        message: this.$t('unsaved_confirm.body'),
        cancelText: this.$t('actions.go_back'),
        confirmText: this.$t('actions.leave'),
        type: 'is-black',
        onConfirm: () => {
          this.$emit('close')
        }
      })
    },
    addNotes() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        component: EditNotes,
        props: {
          appointmentId: this.appointmentId,
          value: this.notes
        },
        events: {
          input: notes => {
            this.notes = notes
          }
        },
        canCancel: ['escape']
      })
    }
  }
}
</script>
